import { render, staticRenderFns } from "./addCostPopup2.vue?vue&type=template&id=48740a62&scoped=true"
import script from "./addCostPopup2.vue?vue&type=script&lang=ts"
export * from "./addCostPopup2.vue?vue&type=script&lang=ts"
import style0 from "./addCostPopup2.vue?vue&type=style&index=0&id=48740a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48740a62",
  null
  
)

export default component.exports